module.exports = __webpack_public_path__ + "img/20240523_liyuzhe.a5d4d178.jpg";